__turbopack_context__.v({
  "bbaButton": "LoginPage-module__kRfS1q__bbaButton",
  "buttonsContainer": "LoginPage-module__kRfS1q__buttonsContainer",
  "orLine": "LoginPage-module__kRfS1q__orLine",
  "terms": "LoginPage-module__kRfS1q__terms",
});
